import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, Tabs, List, Switch } from 'antd'
import { req_list_eps_configBlogMneu, req_edit_eps_configBlogMneu } from '../../api'

const { TabPane } = Tabs
class BlogConfig extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        deviceWidth: 0,
        userLevel: 'NORMAL',
        items: [],
        item: {},
        loading: false,
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.api_list_items()
    }


    // 遠端數據處理 //////////////////////////////////////////////

    api_list_items = async () => {
        const { token, userCode } = this.props.user
        this.setState({ loading: true, items: [] })
        const result = await req_list_eps_configBlogMneu(userCode, token)
        this.setState({ loading: false })
        console.log(result.data);
        if (result.total > 0) {
            const menu = result.data
            const items = menu.reduce(function (accumulator, property) {
                accumulator[property.TopItemName] = accumulator[property.TopItemName] || [];
                accumulator[property.TopItemName].push(property);
                return accumulator;
            }, []);
            //const items = result.data
            this.setState({ items })
            //console.log(this.state);
        } else {
            const items = []
            this.setState({ items })
        }
    }

    api_edit_item  = async (item) => {
        const { token } = this.props.user
        await req_edit_eps_configBlogMneu(item, token)
    }
    // 操作互動處理 //////////////////////////////////////////////

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    onChangeStatus = (e, item) => {
         const { TopItemCode, DownItemCode, SetValue, BloggerCode  } = item
         const tagret = {
            TopItemCode: TopItemCode, 
            DownItemCode: DownItemCode, 
            SetValue:SetValue, 
            BloggerCode:BloggerCode
         }
         this.api_edit_item(tagret)
         const NewSetValue = SetValue === 'NA' ? 'SET' : 'NA'
         const { items } = this.state

         Object.keys(items).map((item, i) => {
            items[item].map((obj, index) => {
                if(obj.TopItemCode === tagret.TopItemCode && obj.DownItemCode === tagret.DownItemCode){
                    obj.SetValue = NewSetValue
                }
                return null
            })
            return null
         })
         this.setState(items)
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { items } = this.state
        return (
            <Card>
                <Tabs defaultActiveKey="1" >
                    {Object.keys(items).map((item, i) => (
                        <TabPane tab={item} key={i}>
                            <List
                                itemLayout="horizontal"
                                dataSource={items[item]}
                                renderItem={obj => (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={<Switch checkedChildren="顯示" unCheckedChildren="隱藏" defaultChecked ={obj.ShowStatus === 'ON'} onChange={e => this.onChangeStatus(e,obj)} />}
                                            title={ <span style={{ fontSize: '1.4em' }}>{obj.DownItemName}</span>}
                                            description={ <span style={{ fontSize: '1.2em' }}>{obj.Description}</span>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </TabPane>
                    ))}
                </Tabs>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(BlogConfig)